import styled, { css } from 'styled-components'
import { Button } from '@sainsburys-tech/bolt'
import { themeContract } from './M027.theme.contract'
import { remCalculator } from '../../../helpers/theming/utilities'

const paddingTop = 125

// GOL image styles should be removed when DS grid migration is done
const GOLImageContainerCSS = css`
  margin-left: 0;
  margin-right: 0;
  flex: 0 0 100%;
  max-width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: stretch;
`

const GOLImageWrapperCSS = css`
  margin-left: 0;
  margin-right: 0;
  flex: 0 0 100%;
  max-width: 100%;
  ${(props) =>
    props.hasTwoImages &&
    css`
      @media screen and (min-width: ${props.theme.size.breakpoint['min-width'].sm}) {
        ${props.isSecondaryImage &&
        css`
          display: block;
        `}
        flex: 0 0 50%;
        max-width: 50%;
      }
    `}
  ${(props) =>
    props.isSecondaryImage &&
    css`
      display: none;
    `}
`

const Container = styled.div`
  display: block;
  width: 100%;
  text-decoration: none;
  /* TODO: discuss with UX if the whole component needs to be clickable */
  &:hover,
  &:active {
    color: unset;
  }

  ${(props) =>
    css`
      margin-bottom: ${remCalculator(
        props.theme.size.spacing[themeContract[props.theme.channel].container.marginBottom]
      )};
      color: ${props.theme.color.palette[themeContract[props.theme.channel].heading.color]};
    `}
`

const ImageContainer = styled.a`
  margin-bottom: ${(props) => remCalculator(props.theme.size.spacing.lg)};
  display: flex;

  img {
    object-fit: cover;
    width: 100%;
    height: 100%;
  }

  &:before {
    padding-top: ${paddingTop}%;
    content: '';
    display: block;
  }

  ${(props) =>
    !props.insideGrid &&
    css`
      &:before {
        @media screen and (min-width: ${props.theme.size.breakpoint['min-width'].sm}) {
          padding-top: 56.25%;
        }
      }
    `}
`

const Images = styled.div`
  width: 100%;
  ${(props) =>
    props.theme.channel === 'sainsburys' &&
    css`
      ${GOLImageContainerCSS}
    `}
`

const ImageWrapper = styled.div`
  height: 100%;
  ${(props) =>
    props.theme.channel === 'sainsburys' &&
    css`
      ${GOLImageWrapperCSS}
    `}
`

const Heading = styled.h3`
  margin-bottom: ${(props) =>
    remCalculator(props.theme.size.spacing[themeContract[props.theme.channel].heading.marginBottom])};
  text-align: center;
`

const M027Button = styled(Button)`
  ${(props) =>
    css`
      &:hover {
        display: flex;
        justify-content: center;
        ${props.theme.channel === 'argos' &&
        css`
          color: ${props.theme.color.monochrome.darker};
          border-color: ${props.theme.color.monochrome.darker};
        `}
      }

      ${props.theme.channel === 'argos' &&
      css`
        color: ${props.theme.color.monochrome.darker};
        border-color: ${props.theme.color.monochrome.darker};
      `}

      ${props.theme.channel === 'tu' &&
      css`
        border-radius: 0;
      `}
    `}
`

const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
`

export { Container, ImageContainer, Images, ImageWrapper, Heading, M027Button, ButtonContainer }
